import React from 'react';
import classes from './ToolbarSeparator.module.css';

const ToolbarSeparator = () => {
  return (
    <div className={classes.Vl + ' dx-widget '}></div>
  );
};

export default ToolbarSeparator;
